import { Component, Input } from '@angular/core'
import { Model } from '../../../pages/planner/model/Model'
import { Mesh } from 'formwork-planner-lib'

@Component({
  selector: 'efp-context-menu-center-button-container',
  templateUrl: 'context-menu-center-button-container.component.html',
  styleUrls: ['context-menu-center-button-container.component.scss'],
})
export class ContextMenuCenterButtonContainerComponent {
  @Input() useCenterView?: boolean = false
  @Input() model?: Model<Mesh>
  @Input() centerContextMenu?: boolean = false
}
